import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StripeTerminalSignalRService {

  private hubConnection: signalR.HubConnection;
  private stripeResponseSubject = new Subject<any>();
  public stripeResponse$ = this.stripeResponseSubject.asObservable();

  public startConnection(baseUrl): void {
    baseUrl = baseUrl.replace('/api', '/');
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(baseUrl + 'StripePaymentHub') // Replace with your SignalR hub URL
      .build();

    this.hubConnection
      .start()
      .then(() => console.log('SignalR connection started'))
      .catch(err => console.error('Error while starting SignalR connection: ' + err));
  }

  public addStripeResponseListener(listenerString : string): void {
    this.hubConnection.on(listenerString, (response : any) => {
      console.log('Stripe response received:', response);
      this.stripeResponseSubject.next(response);
    });
  }

  public stopConnection(): void {
    if (this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected) {
      this.hubConnection.stop()
      .then(() => console.log('SignalR connection stopped'))
      .catch(err => console.error('Error while stopping SignalR connection: ' + err));
    }else{
      console.log('No active SignalR connection to stop');
    }
  }
}
